import Account from "../services/account";
import Auth from "../services/auth";
import { EventBus } from "../event-bus";

export default {
  props: ["address", "user", "typePurchase"],
  data() {
    return {
      userAddress: [],
      newAddress: {},
      registerAddress: false,
      selectedAddress: undefined,
      loading: undefined,
      errorCep: undefined,
      lastAddressInsert: undefined,
      allFieldsValid: false,
    };
  },
  watch: {
    newAddress: {
      handler: function () {
        this.allFieldsValid = this.validateAllFields();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    currentUser() {
      if (Auth) return Auth._currentUser;
    },
  },
  created() {
    this.$watch(
      "newAddress",
      () => {
        let vm = this;
        setTimeout(function () {
          vm.$validator
            .validateAll()
            .then(() => {
              vm.newAddress.validForm = true;
              $("#create-address").prop("disabled", false);
            })
            .catch((err) => {
              vm.newAddress.validForm = false;
            });
        }, 300);
      },
      { deep: true }
    );

    if (this.address && !this.currentUser) {
      this.userAddress.push(this.address);
    } else {
      this.getAddress();
    }
  },
  methods: {
    getLastInsertAddress() {
      this.loading = Account.getAddressDeliveryList(
        this.currentUser.moveMaisId
      ).then((resp) => {
        this.userAddress = resp;
        var maxValueAdress = this.userAddress.length - 1;
        this.lastAddressInsert = this.userAddress[maxValueAdress];
        this.$emit("deliveryAddress", this.lastAddressInsert);
      });
    },
    changeAddress() {
      this.$emit("deliveryAddress", this.selectedAddress);
      if (!this.currentUser) {
        this.$emit("allAddresses", this.userAddress);
      }
    },
    getAddress() {
      this.loading = Account.getAddressDeliveryList(this.currentUser.moveMaisId)
        .then((resp) => {
          this.userAddress = resp;
        })
        .catch((err) => {});
    },
    validateAllFields() {
      const requiredFields = [
        "zipCode",
        "address",
        "number",
        "neighborhood",
        "city",
        "state",
      ];
      return requiredFields.every(
        (field) =>
          this.newAddress[field] &&
          typeof this.newAddress[field] === "string" &&
          this.newAddress[field].trim().length > 0
      );
    },
    createAddress() {
      if (this.typePurchase != "ADHESION") {
        this.newAddress.type = "DELIVERY";
      }
      if (this.typePurchase == "ADHESION") {
        this.newAddress.type = "MAILING";
      }
      if (this.currentUser) {
        this.newAddress.moveMaisId = this.currentUser.moveMaisId;
        this.loading = Account.insertAddress(this.newAddress)
          .then((res) => {
            this.getLastInsertAddress();
          })
          .catch((err) => {});
      } else {
        this.userAddress.push(this.newAddress);
        this.$emit("allAddresses", this.userAddress);
      }

      // this.changeAddress();
      this.newAddress = {};
      this.registerAddress = false;

      // this.changeAddress();
      // location.reload();
    },
    queryAddress() {
      this.errorCep = undefined;
      this.loading = Account.queryAddress(this.newAddress.zipCode)
        .then((resp) => {
          this.newAddress = resp;

          if (
            this.newAddress.address.length == 0 &&
            this.newAddress.neighborhood.length == 0
          ) {
            this.newAddress.number = "";
          }
        })
        .catch((err) => {
          this.errorCep = err.data.status.message;
          this.$validator.validateAll();
        });
    },
    queryAddressTyping() {
      if (
        this.newAddress.zipCode.length > 0 &&
        this.newAddress.zipCode.length < 8
      )
        return;

      this.queryAddress();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/modal-address.js